
export const DEPS_TYPES = {
    PENDING: 'EN ATTENTE',
    LOCK: 'BLOCAGE',
    TASK: 'TÂCHES',
}